import { WalkthroughContentDto } from './WalkthroughContentDto';
import { KeyValuePair } from './KeyValuePair';

export type WalkthroughPathEntry = KeyValuePair<string, WalkthroughContentDto>;
